import { router } from '../../router.js';

export function registerAuthRoutes() {
    router.add('/login', () => import('./login.js'));
    router.add('/register', () => import('./register.js'));
    router.add('/forgot-password', () => import('./forgot-password.js'));
    router.add('/reset-password', () => import('./reset-password.js'));
    router.add('/accept-invite', () => import('./accept-invite.js'));
    router.add('/verify-email', () => import('./verify-email.js'));
}
